<template>
     <v-container grid-list-xs>
         <!-- align-center justify-center  -->
            <v-layout row class="amount_container">
                <v-flex xs12 sm12 md12 lg12 xl0>
                    <div class="fdca_container">
                        <v-container grid-list-xl>
                            <v-layout id="premium-container" row wrap>
                                <v-flex xs12 sm12 md12 lg12 xl12>
                                    <v-card flat class="premium-box">
                                        <div class="border__bottom"> 
                                            <v-card-text>
                                                <h3>PRODUCT SUMMARY</h3>
                                            </v-card-text>
                                        </div>
                                        <v-card-text>
                                            <p>FDCA Membership</p>
                                            <!-- <p>{{ this.$parent.$parent.EducatorInsuranceProcess.commencement_date }} &ndash; 2020-6-30</p> -->
                                            <p>Family Day Care Insurance for Educators</p>
                                            <p v-if="this.tla == true">Telephone Legal Assistance</p>
                                            <p v-if="this.dr == true">Debt Recovery</p>
                                        </v-card-text>
                                        <v-card-text>
                                            <p><span>Term:</span><span class="right">12 months</span></p>
                                            <p><span>START DATE:</span><span class="right">{{ this.$parent.$parent.EducatorInsuranceProcess.commencement_date }}</span></p>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12 sm12 md12 lg12 xl12>
                                    <v-card flat class="premium-box">
                                        <div class="border__bottom"> 
                                            <v-card-text>
                                                <h3>PREMIUM BREAKDOWN</h3>
                                            </v-card-text>
                                        </div>
                                        <v-card-text>
                                            <p><span>Membership Fee:</span><span class="right">${{ this.$parent.$parent.EducatorInsuranceProcess.breakdown.membership_fee }}</span></p>
                                            <p><span>Public Liability Premium:</span><span class="right">${{ this.$parent.$parent.EducatorInsuranceProcess.breakdown.parent.base_premium }}</span></p>
                                            <p><span>Personal Accident Premium:</span><span class="right">${{ this.$parent.$parent.EducatorInsuranceProcess.breakdown.child.base_premium }}</span></p>
                                            <p><span>FDCA Legal Services:</span><span class="right">${{ this.$parent.$parent.EducatorInsuranceProcess.breakdown.additional_cover_total }}</span></p>
                                            <p><span>FDCA Broker Fee:</span><span class="right">${{ this.$parent.$parent.EducatorInsuranceProcess.breakdown.parent.fdca_fee }}</span></p>
                                        </v-card-text>
                                        <v-card-text>
                                            <p><span>Total GST:</span><span class="right">${{ this.$parent.$parent[this.process].breakdown.total_gst}}</span></p>
                                            <p><span>Stamp Duty:</span><span class="right">${{ this.$parent.$parent[this.process].breakdown.total_stamp_duty}}</span></p>
                                            <p v-if="this.$parent.$parent[this.process].breakdown.payment_type != 'yearly'"><span>Interest - Premium Funding:</span><span class="right">${{ this.$parent.$parent.EducatorInsuranceProcess.breakdown.interest }}</span></p>
                                        </v-card-text>
                                        <v-card-text>
                                            <p class="bold"><span>TOTAL</span><span class="right">${{this.$parent.$parent[this.process].breakdown.total}}</span></p>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>

                                <PremiumPoliceChecked></PremiumPoliceChecked>

                                <!-- <v-flex xs12 sm12 md12 lg12 xl8>
                                    <v-card flat class="premium-box text-xs-center">
                                        <v-card-text class="pa-3">
                                            <h3>Complete your Police Checked?</h3>
                                            <p class="mb-1">Claim $15 off your policy with your FDCA Polic Checks promo code</p>
                                            <p class="mb-0"><a href="https://fdcapolichecks.com.au" target="_blank">fdcapolichecks.com.au</a></p>
                                        </v-card-text>
                                    </v-card>
                                </v-flex> -->
                            </v-layout>
                            


                            
                            
                        </v-container>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
</template>

<script>
// class="educator-route-nav educator-package-nav no_progress_bar"
import IconBase from '@/components/IconBase.vue'
import IconArrowRight from '@/components/icons/arrowForward.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconStarCheck from '@/components/icons/starCheck.vue'
import Globals from '@/assets/scripts/global-functions.js'
import IconInformation from '@/components/icons/information.vue'
import PremiumPoliceChecked from '@/components/forms/PremiumPoliceChecked.vue'

export default {
    name: "PremiumBreakdown",
    components: {
        IconBase,
        IconArrowRight,
        IconArrowBack,
        IconStarCheck,
        Globals,
        IconInformation,
        PremiumPoliceChecked
    },
    props: {
    },
    data() {
        return {
            dialog_info: false,
            process: "",
            tla: false, //Telephone Legal Advice,
            dr: false, //Debt Recovery,
            total_gst: 0,
            payment_type:"yearly"
            
        }
    },
    mounted() {
        this.$parent.$parent.CheckWindowPathName();

        this.process = this.$parent.$parent.ReturnProcess();
        this.total_gst = this.$parent.$parent[this.process].breakdown.total_gst;
        this.total_stamp_duty = this.$parent.$parent[this.process].breakdown.total_stamp_duty;
        this.payment_type = this.$parent.$parent[this.process].breakdown.payment_type;
        let additional_cover = this.$parent.$parent[this.process].additional_cover;

        if(additional_cover.length > 0 || additional_cover != undefined){
            this.tla = this.CheckIfExist(additional_cover, 'Telephone Legal Advice');
            this.dr = this.CheckIfExist(additional_cover, 'Debt Recovery service');
        }

    },
    methods: {
        CheckIfExist(_array, _element){
            if(_array.indexOf(_element) != -1){
                return true;
            }else{
                return false;
            }
        }
        
    }
}
</script>

<style lang="scss" scoped>
    .insurance-process-step h3 {
        margin-bottom: 0;
        color: #0A2435;
        font-weight: 600;
        
    }

    .insurance-process-step p {
        font-size: 1.1rem;
        /* text-align: center; */
        color: #0a2435;
        line-height: 35px;
        margin-bottom: 0; 
    }
    

    .back-container {
        padding-top: 40px;
    }

    .back-container a {
        color: #fff;
        float: left;
    }

    @media screen and (max-width: 1263px) and (min-width: 0px) {
        .main_inner_container {
            margin-left: 5%;
            margin-right: 5%;
        }
    }

    .amount_expansion .flex{padding: 8px 0px 0px 0px !important;}
    .expansion_header {text-transform: uppercase}
    .icolor {color: #0072BC}
    .icolor svg { vertical-align: middle; margin-right: 5px;}

    //.with_back_btn_con { display:none;}

    .with_back_btn_con svg {color:#0a2435; vertical-align: middle;display: none;}
    .nav_close_container{margin-top: 15px}

    @media only screen and (max-width: 959px){
        .amount_expansion__container {padding:0px;}
        .with_back_btn_con svg{display:initial}
        //.with_back_btn_con { display: initial}
    }


    .modal_body__content { margin-bottom: 20px;}
    .atooltip { margin-left: 10px;}

    #premium-container {
        .premium-box {
            border: 1px solid #e0dede;
            border-radius: 5px;
            .v-card__text {
                border-bottom: 1px solid #e0dede;
            }
            .v-card__text:last-child {
                border-bottom: none;
            }
        }
    }

    .span_text { font-size: 1rem;cursor: pointer;}

    .border__bottom{
        border-bottom: 1px solid #e0dede;
    }
    
    .right{
        float:right
    }

    .bold{
        font-weight: 600;
    }




</style>
